


































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import CloseIcon from '@/components/icons/Close.vue';
import CheckIcon from '@/components/icons/Check.vue';

// category icons
import FilmIcon from '@/components/icons/categories/Film.vue';
import CompassIcon from '@/components/icons/categories/Compass.vue';
import ProfileIcon from '@/components/icons/categories/Profile.vue';
import EducationIcon from '@/components/icons/categories/Education.vue';
import ClipboardIcon from '@/components/icons/categories/Clipboard.vue';
import CoffeeIcon from '@/components/icons/categories/Coffee.vue';
import HeartIcon from '@/components/icons/categories/Heart.vue';
import HomeIcon from '@/components/icons/categories/Home.vue';
import PinIcon from '@/components/icons/categories/Pin.vue';
import HeadphonesIcon from '@/components/icons/categories/Headphones.vue';
import MusicIcon from '@/components/icons/categories/Music.vue';
import PetsIcon from '@/components/icons/categories/Pets.vue';
import ToolIcon from '@/components/icons/categories/Tool.vue';
import RealEstateIcon from '@/components/icons/categories/RealEstate.vue';
import ShopIcon from '@/components/icons/categories/Shop.vue';
import BasketballIcon from '@/components/icons/categories/Basketball.vue';
import MapIcon from '@/components/icons/categories/Map.vue';
import PlusCircleIcon from '@/components/icons/PlusCircle.vue';

@Component({
  components: {
    Typography,
    CloseIcon,
    CheckIcon,
    FilmIcon,
    CompassIcon,
    ProfileIcon,
    EducationIcon,
    ClipboardIcon,
    CoffeeIcon,
    HeartIcon,
    HomeIcon,
    PinIcon,
    HeadphonesIcon,
    MusicIcon,
    PetsIcon,
    ToolIcon,
    RealEstateIcon,
    ShopIcon,
    BasketballIcon,
    MapIcon,
    PlusCircleIcon
  }
})
export default class CategoryItem extends Vue {
  @Prop({ default: '' }) readonly name!: string;
  @Prop({ default: '' }) readonly icon?: string;
  @Prop({ default: false }) readonly active?: boolean;
  @Prop({ default: false }) readonly disabled?: boolean;
  @Prop({ default: false }) readonly isTextField?: boolean;
  @Prop({ default: false }) readonly hasError?: boolean;

  iconMap: Record<string, string> = {
    'Arts & Entertainment': 'FilmIcon',
    'Automotive, Aircraft, Boat': 'CompassIcon',
    'Beauty, Cosmetic & Personal Care': 'ProfileIcon',
    'Beauty & Personal Care': 'ProfileIcon',
    'Event Planning': 'ClipboardIcon',
    'Food & Drink': 'CoffeeIcon',
    'Health & Fitness': 'HeartIcon',
    'Home Services': 'HomeIcon',
    'Local Services': 'PinIcon',
    'Professional Services': 'ToolIcon',
    'Real Estate': 'RealEstateIcon',
    'Shopping & Retail': 'ShopIcon',
    'Sports & Recreation': 'BasketballIcon',
    'Travel & Transportation': 'MapIcon',
    Media: 'HeadphonesIcon',
    Nightlife: 'MusicIcon',
    Pets: 'PetsIcon',
    Education: 'EducationIcon',
    Other: 'PlusCircleIcon',
    Others: 'PlusCircleIcon'
  };

  get categoryIcon() {
    return this.iconMap[this.icon || ''];
  }
}
